<script lang="ts">
	import detailIcon from "@assets/icons/detail.svg?raw";
	import arrowIcon from "@core/assets/icons/arrow-next.svg?raw";
	import { homepageData } from "../../data/homepageData.js";
	import { homepageImages } from "../../data/homepageImages.js";
	import Formatted from "../common/Formatted.svelte";
	import Link from "../common/Link.svelte";
	import Media from "../common/Media.svelte";
	import { ButtonVariant } from "../common/getButtonClass.js";

	const steps = homepageData.steps.map((step) => {
		const img = homepageImages[step.imageKey as keyof typeof homepageImages];
		return {
			...step,
			image: typeof img === "string" ? { mobile: img, desktop: img } : img,
		};
	});
</script>

<section class="grid-container">
	<div class="full-width">
		<div class="flex flex-col gap-3 md:gap-4">
			{#each steps as step (step.number)}
				<div
					class="flex flex-col xl:flex-row items-stretch p-4 md:p-8 lg:p-16 xl:p-24 gap-4 md:gap-8 lg:gap-16 xl:gap-32 bg-ivory-100 rounded-[2rem] md:rounded-[4rem] lg:rounded-[6rem] xl:rounded-[8rem]"
				>
					<div class="flex flex-col justify-between flex-1 gap-4 md:gap-6">
						<div class="flex flex-col gap-3 md:gap-6 xl:gap-6">
							<div class="flex flex-col gap-2 xl:max-w-[40.67rem]">
								<h3
									class="font-heading font-bold text-lg md:text-2lg xl:text-[2.5rem] leading-[1.1] xl:leading-[1.2] text-hazelnut-500"
								>
									<Formatted text={step.headline} />
								</h3>
							</div>
						</div>

						<div>
							<p
								class="text-text-mobile md:text-[1.0625rem] md:leading-[1.6875rem] md:font-normal font-medium text-midnight"
							>
								<Formatted text={step.text} />
							</p>
							{#if step.buttonText && step.buttonHref}
								<div class="mt-4 md:mt-6 xl:mt-8">
									<Link href={step.buttonHref} variant={ButtonVariant.PrimarySmall} iconEnd={arrowIcon}>
										{step.buttonText}
									</Link>
								</div>
							{/if}
						</div>
					</div>

					<div
						class="w-full xl:w-[341px] h-[16rem] md:h-[20rem] lg:h-[22rem] xl:h-[26rem] [@media(max-height:700px)]:h-[14rem] [@media(max-height:700px)]:lg:h-[16rem] [@media(max-height:700px)]:xl:h-[18rem] flex-shrink-0"
					>
						<Media
							source={{ src: String(step.image.desktop), type: "image" }}
							sourcesets={{
								"<md": String(step.image.mobile),
								">md": String(step.image.desktop),
							}}
							alt={step.imageAlt}
							width={341}
							height={512}
							class="w-full h-full object-cover rounded-[1rem] md:rounded-[1.5rem] lg:rounded-[2rem] xl:rounded-[32px]"
							eager
						/>
					</div>
				</div>
			{/each}
		</div>

		<div class="flex justify-center mt-6 md:mt-8 xl:mt-12">
			<Link href="/procedury" variant={ButtonVariant.PrimaryMedium} iconStart={detailIcon}>
				Chci si vybrat proceduru
			</Link>
		</div>
	</div>
</section>
